/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Marionette = require('backbone.marionette');
var Ladda = require('ladda');
var Syphon = require('backbone.syphon');
var _ = require('underscore');

var SubmitNewFiling = require('../../filing-forms/services/SubmitNewFiling');

var tmplDepEntitySelectFilingTypeModalView = require('../templates/DepEntitySelectFilingTypeModalView.hbs');

module.exports = Marionette.LayoutView.extend({
  template: tmplDepEntitySelectFilingTypeModalView,

  templateHelpers: function() {
    var entityIdentifiers = this.model.get('entityIdentifiers');
    var filingTypes = this.model.get('filingTypes');
    var categoryId = entityIdentifiers.categoryId;
    var charterTypeId = entityIdentifiers.charterTypeId;
    var isCollectiveInvestmentFund = entityIdentifiers.isCollectiveInvestmentFund;
    var FOMTypeId = entityIdentifiers.FOMTypeId;
    var EntityTypeId = entityIdentifiers.entityTypeId;

    // remove Bank filing type "Collective Investment / Common Trust" (111) unless:
    // Charter Type is "Bank and Trust" (2) or "Savings Bank with Trust" (31) AND
    // isCollectiveInvestmentFund === '1'
    if (!(['2', '31'].includes(charterTypeId) && isCollectiveInvestmentFund === '1')) {
      filingTypes = _.filter(filingTypes, function(filingType) {
        return filingType.id !== '111';
      });
    }

    // remove Trust filing type "Collective Investment / Common Trust" (305) unless:
    // Charter Type is "Trust Company" (21) AND
    // isCollectiveInvestmentFund === '1'
    if (!(charterTypeId === '21' && isCollectiveInvestmentFund === '1')) {
      filingTypes = _.filter(filingTypes, function(filingType) {
        return filingType.id !== '305';
      });
    }

    // remove Credit Union filing type "SEG Request" (204) unless FOM Type is "SEG" (1)
    if (categoryId === '2' && FOMTypeId !== '1') {
      filingTypes = _.filter(filingTypes, function(filingType) {
        return filingType.id !== '204';
      });
    }

    // remove Trust filing type "Foreign Fiduciary" (329) unless Emtity Type is "Foreign Fiduciary" (24)
    if (categoryId === '3' && EntityTypeId !== '24') {
      filingTypes = _.filter(filingTypes, function(filingType) {
        return filingType.id !== '329';
      });
    }

    return {
      filingTypes: filingTypes
    };
  },

  className: 'dep-ext-entity-select-filing-type-modal-view',

  ui: {
    cancelButton: '.btn-cancel',
    submitButton: '.btn-submit',
    selectFilingType: '.select-filing-type',
    noFilingTypeSelected: '#noFilingTypeSelected'
  },

  events: {
    'click @ui.submitButton': 'onClickSubmit'
  },

  onClickSubmit: function(e) {
    e.preventDefault();
    var isValid = this.validate(this.ui.selectFilingType);

    if (!isValid) {
      return;
    }
    var self = this;
    var entityId = self.model.get('entityId');
    var isExternalFiling = self.model.get('isExternalFiling');
    this.ui.selectFilingType
      .parsley()
      .whenValidate()
      .done(function() {
        var data = Syphon.serialize(self);
        (data.entityId = entityId), (data.isExternalFiling = isExternalFiling);
        var laddaContext = Ladda.create(self.ui.submitButton.get(0));
        laddaContext.start();
        SubmitNewFiling(data)
          .done(function(response) {
            self.triggerMethod('modal:close', response);
          })
          .fail(function() {
            laddaContext.stop();
          });
      });
  },

  validate: function(selectedFilingType) {
    this.ui.noFilingTypeSelected.hide();
    if (!selectedFilingType.val()) {
      this.ui.noFilingTypeSelected.show();
      return false;
    } else {
      this.ui.noFilingTypeSelected.hide();
      return true;
    }
  }
});
